// extracted by mini-css-extract-plugin
export var paragraphtextareainner = "ParagraphTextArea-module--paragraphtextareainner--2c2e7";
export var tableinnerwrapper = "ParagraphTextArea-module--tableinnerwrapper--5298b";
export var tableouterwrapper = "ParagraphTextArea-module--tableouterwrapper--2b76c";
export var textarea = "ParagraphTextArea-module--textarea--d085b";